class ClientApi {
  static setLastGeneratedMember(data) {
    return data;
  }
}

export default ClientApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientApi.js